import { Component } from '@angular/core';

@Component({
  selector: 'app-preview-validation',
  standalone: false,
  templateUrl: './preview-validation.component.html',
})
export class PreviewValidationComponent {
  constructor() {}
}
